import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

const ROW_ID = 1;

export function useWebsiteFeaturedSeries() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['websiteFeaturedSeries'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_featured_series')
        .select('series_id, updated_at')
        .eq('id', ROW_ID)
        .maybeSingle();
      if (error) throw error;
      return (data?.series_id ?? null) as string | null;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (seriesId: string | null) => {
      const { error } = await supabase
        .from('website_featured_series')
        .update({ series_id: seriesId, updated_at: new Date().toISOString() })
        .eq('id', ROW_ID);
      if (error) throw error;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['websiteFeaturedSeries'] }),
  });

  return {
    featuredSeriesId: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
    setFeaturedSeries: updateMutation.mutateAsync,
    setLoading: updateMutation.isPending,
  };
}
